import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { popiSuccess, popiRequest, popiFailure } from '../reducers/popi';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/setPopi/`;

function* popiAxios() {

  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const response = yield call(() => {

  return axios({
    method: 'post',
    url: API+userId+'?approval=1',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'same-origin',
  });
});

  return response;
}

function* workerPopiSaga() {
  try {
    const response = yield call(popiAxios);
    const responseFrompopi= response.data.message[1];
    
    yield put(popiSuccess(responseFrompopi));
    if (response.status === 500) {
      yield put(popiFailure(responseFrompopi));
    }
  } catch (error) {
     yield put(popiFailure(error));
  }
}

export function* watcherPopiSaga() {
  yield takeLatest(popiRequest().type, workerPopiSaga);
}
